import { toast } from 'react-toastify';
import { toastError } from '../../../../utils';
import { callApi } from '../../../../apiCaller';

import {
     setIsWaiting,
     setIsLoading,
     setRemoveLoading,
     setShowRemovePopup,
     setShowPopup,
     setShowPopupDetail,
     setShowRelatedObjectWarningPopup,
} from '../../../../actions/general';
import { GENERAL_MODE, POPUP_TYPE } from '../../../../constants';

// import { setAdminDataAddProduct } from '../GlobalStates/DataAddProduct/actions';

export const ADD_ADMIN_SELLING_GROUP_CATEGORY = 'addAdminSellingGroupCategory';
export const ADD_ADMIN_SELLING_GROUP_CATEGORIES = 'addAdminSellingGroupCategories';
export const UPDATE_ADMIN_SELLING_GROUP_CATEGORY = 'updateAdminSellingGroupCategory';
export const DELETE_ADMIN_SELLING_GROUP_CATEGORY = 'deleteAdminSellingGroupCategory';
export const API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORY = 'selling-group-category/:id';
export const API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORIES = 'selling-group-category';
export const API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORY_DELETE_CHECKING = 'selling-group-category/delete-checking/:id/:model';

const addAdminSellingGroupCategory = (sellingGroupCategory) => {
     return {
          type: ADD_ADMIN_SELLING_GROUP_CATEGORY,
          payload: sellingGroupCategory,
     };
};

const addAdminSellingGroupCategories = (sellingGroupCategories) => {
     return {
          type: ADD_ADMIN_SELLING_GROUP_CATEGORIES,
          payload: sellingGroupCategories,
     };
};

const updateAdminSellingGroupCategory = (sellingGroupCategory) => {
     return {
          type: UPDATE_ADMIN_SELLING_GROUP_CATEGORY,
          payload: sellingGroupCategory,
     };
};

const deleteAdminSellingGroupCategory = (sellingGroupCategory) => {
     return {
          type: DELETE_ADMIN_SELLING_GROUP_CATEGORY,
          payload: sellingGroupCategory,
     };
};

// export const addSellingGroupCategoryToDataAddProduct = (sellingGroupCategory) => (dispatch, getState) => {
//      const dataAddProduct = getState().admin.dataAddProduct;

//      if (dataAddProduct?.sellingGroupCategories) {
//           dataAddProduct.sellingGroupCategories.push(sellingGroupCategory);
// dispatch(setAdminDataAddProduct(dataAddProduct));
//      }
// }

// export const updateSellingGroupCategoryToDataAddProduct = (sellingGroupCategory) => (dispatch, getState) => {
//      const dataAddProduct = getState().admin.dataAddProduct;
//      if (dataAddProduct !== null) {
//           const newDataSellingGroupCategories = dataAddProduct.sellingGroupCategory.map((sellingGroupCategoryItem) => {
//                if (sellingGroupCategoryItem.id === sellingGroupCategory.id) {
//                     return { ...sellingGroupCategoryItem, ...sellingGroupCategory };
//                }
//                return sellingGroupCategoryItem;
//           });
//           dataAddProduct.sellingGroupCategories = newDataSellingGroupCategories;
//           dispatch(setAdminDataAddProduct(dataAddProduct));
//      }
// };

// export const deleteSellingGroupCategoryFromDataAddProduct = (sellingGroupCategory) => (dispatch, getState) => {
//      const dataAddProduct = getState().admin.dataAddProduct;

//      if (dataAddProduct !== null) {
//           const newSellingGroupCategories = dataAddProduct.sellingGroupCategories.filter(
//                (sellingGroupCategoryItem) => sellingGroupCategoryItem.id !== sellingGroupCategory
//           );
//           dataAddProduct.sellingGroupCategories = newSellingGroupCategories;
//           dispatch(setAdminDataAddProduct(dataAddProduct));
//      }
// };

export const fetchSystemAdminSellingGroupCategoryList = () => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORIES, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               dispatch(addAdminSellingGroupCategories(response.data));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const addSystemAdminSellingGroupCategoryRequest = (sellingGroupCategory) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORIES, 'POST', sellingGroupCategory)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(true);
                    return;
               }
               const newSellingGroupCategory = response.data;
               dispatch(addAdminSellingGroupCategory(newSellingGroupCategory));

               // dispatch(addSellingGroupCategoryToDataAddProduct(newSellingGroupCategory));
               dispatch(setShowPopup());
               toast.success('Created Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const updateSystemAdminSellingGroupCategoryRequest = (sellingGroupCategoryId, newSellingGroupCategory) => (dispatch) => {
     callApi(API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORY.replace(':id', sellingGroupCategoryId), 'PUT', newSellingGroupCategory)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(updateAdminSellingGroupCategory(response.data));

                    // dispatch(updateSellingGroupCategoryToDataAddProduct(response.data));
                    dispatch(setShowPopupDetail(null));
                    toast.success('Update Successfully');
               }
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const deleteSystemAdminSellingGroupCategoryRequest = (sellingGroupCategoryId) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORY.replace(':id', sellingGroupCategoryId), 'DELETE')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
                    return;
               }
               dispatch(deleteAdminSellingGroupCategory(sellingGroupCategoryId));
               // dispatch(deleteSellingGroupCategoryFromDataAddProduct(sellingGroupCategoryId));
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const checkCanDeleteSellingGroupCategoryRequest = (sellingGroupCategoryId) => (dispatch) => {
     callApi(
          API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORY_DELETE_CHECKING.replace(':id', sellingGroupCategoryId).replace(':model', GENERAL_MODE.DELETE),
          'GET'
     ).then((response) => {
          if (response.status === 200) {
               if (response.data.canDelete) {
                    dispatch(setShowRemovePopup(sellingGroupCategoryId));
               }
          } else {
               if (response.data.isUsedForProducts) {
                    dispatch(setShowRemovePopup(null));
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
               } else {
                    toastError(response);
               }
          }
     });
};

export const checkUpdateSellingGroupCategoryRequest = (nextDispatch) => (dispatch) => {
     const { isEditing, checkedValue, setFieldValue, setStatus, setStatusLoading, sellingGroupCategoryId } = nextDispatch;

     if (!isEditing && checkedValue) {
          setFieldValue('status', checkedValue);
          return;
     }

     setStatusLoading(true);

     callApi(
          API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORY_DELETE_CHECKING.replace(':id', sellingGroupCategoryId).replace(':model', GENERAL_MODE.UPDATE),
          'GET'
     )
          .then((response) => {
               if (response.status === 200 && response.data.canUpdate) {
                    setFieldValue('status', checkedValue);
                    return;
               }

               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
                    setStatus(!checkedValue);
                    setFieldValue('status', !checkedValue);
                    return;
               }

               toastError(response);
          })
          .finally(() => setStatusLoading(false));
};
